module.exports = __webpack_public_path__ + "img/ercode.f18ec9f7.jpg";